import { Fill, Track } from "./styles";
import { ProgressBarProps } from "./types";

const DEFAULT_MAX = 100;
const DEFAULT_HEIGHT = 10;
const FULL_PCT = 100;
const MIN_PCT = 0;

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = DEFAULT_MAX,
  color = "var(--color-success)",
  trackColor = "var(--color-background-3)",
  height = DEFAULT_HEIGHT,
  minFillPct = MIN_PCT,
  className,
  ariaLabel,
}) => {
  const ratio = max > 0 ? (value / max) * FULL_PCT : 0;
  const pct = Math.min(Math.max(ratio, minFillPct), FULL_PCT);

  return (
    <Track
      className={className}
      $height={height}
      $trackColor={trackColor}
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuenow={Math.round(pct)}
      aria-valuemin={MIN_PCT}
      aria-valuemax={FULL_PCT}
    >
      <Fill $pct={pct} $color={color} />
    </Track>
  );
};
